import $ from 'jquery';
import {gsap, ScrollTrigger} from '../../js/wrapper/gsap.mjs';
import {gridBreakpoints} from '../../js/utilities/media-queries.mjs';
import {initRevealAnimation} from '../../js/Ui.mjs';

const CSS_CLASS_TEASER = '.ef-teaser-fullscreen';
const $teaserFullscreen = $(CSS_CLASS_TEASER);
const windowHeight = innerHeight;

ScrollTrigger.matchMedia({
  // On large devices attach parallax animation
  [`(min-width: ${gridBreakpoints.lg}px) and (prefers-reduced-motion: no-preference)`]: function() {
    $teaserFullscreen.each((index, teaser) => {
      const $teaser = $(teaser);
      const medium = $teaser.find(`${CSS_CLASS_TEASER}__medium-holder`).get(0);
      const image = $teaser.find(`${CSS_CLASS_TEASER}__image`).get(0);
      let isMediumHigherThanWindow = windowHeight < medium.offsetHeight;

      // Cleanup
      gsap.set($teaser, {clearProps: 'all'});

      // Setup
      gsap.set(image, {
        // Consider resize? Good enough for now
        height: isMediumHigherThanWindow ? '100%' : '100vh',
        objectFit: 'cover',
        objectPosition: `50% ${-windowHeight / 2}px`,
      });

      // Animate
      gsap.to(image, {
        objectPosition: `50% ${windowHeight / 2}px`,
        ease: 'none',
        scrollTrigger: {
          // markers: true, // Enable for debug indicators
          trigger: teaser,
          scrub: true,
        },
      });
    });
  },
  // On smaller devices manually cleanup instead of ScrollTrigger.saveStyles()
  // @see https://greensock.com/forums/topic/28364-scrolltriggersavestyles-reset-styles-from-gsapset/
  [`(max-width: ${gridBreakpoints.lg - 1}px), (prefers-reduced-motion)`]: function() {
    $teaserFullscreen.each((index, teaser) => {
      const $teaser = $(teaser);
      const image = $teaser.find(`${CSS_CLASS_TEASER}__image`).get(0);

      // Cleanup
      gsap.set(image, {clearProps: 'all'});

      // Setup
      initRevealAnimation($teaser);
    });
  },
});
